import React from "react";
import Avatar from "../assets/images/avatar.jpg";
import RiceLogo from "../assets/images/RiceLogo.png";
import JWLogo from "../assets/images/JWLogo.png";

import "../App.css";

const About = () => {
  return (
    <React.Fragment>
      <div className="container">
        <div className="row">
          <div className="col">
            <div className="card">
              <div className="card-body">
                <div className="row abstract-back ">
                  <img className="avatar" src={Avatar} />
                </div>
              </div>

              <div className="card-body">
                <div className="row">
                  <p className="p-about">
                    My name is Maria Sullivan, and I live in a Houston Texas
                    suburb. I work for a software company in an Automation QA
                    Engineering role where I use Selenium and the Java language
                    to automate application testing. I truly enjoy developing
                    the code and automating the testing of applications as it
                    saves a lot of time, and I also enjoy improvising the script
                    creation based on business demands. Since I am already
                    working as a programmer , I decided to enroll in the
                    bootcamp to take my career to the next level. I am hoping I
                    will successfully complete the boot camp to add more value
                    to my organization and my future journey. Automation
                    Engineer with a demonstrated history of working on
                    production web and mobile applications. Deep understanding
                    and technical expertise in Computer Science fundamentals,
                    Javascript, ReactJS, Redux, VueJS, Vuex, NodeJS, MongoDB,
                    CSS, HTML and other technologies.
                  </p>
                </div>
              </div>

              <div className="modal-footer" />

              <div className="card-body">
                <h2 className="edu">Education</h2>
                <br />

                <div className="grid-container-profile">
                  <div className="grid-item">
                    <div className="title-uni">Rice University BootCamp</div>
                    <div className="title-concentration">
                      Full Stack Web Development
                    </div>
                  </div>

                  <div className="grid-item">
                    <a href="https://www.berkeley.edu/" target="_blank">
                      <img className="university-logo" src={RiceLogo} />
                    </a>
                  </div>
                  <div className="grid-item">
                    <div className="title-uni">
                      Johnson And Wales University
                    </div>
                    <div className="title-concentration">
                      Bachelor of Computer Science
                    </div>
                  </div>

                  <div className="grid-item">
                    <a href="https://carleton.ca/" target="_blank">
                      <img className="university-logo" src={JWLogo} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default About;
